import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React, { ReactNode, useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { MobileMenuIcon } from '../styles';
import { HeaderContext } from '../HeaderProvider';

type Props = {
  className?: string;
  disabled?: boolean;
  exact?: boolean;
  extraContent?: ReactNode;
  href?: string;
  icon?: IconProp;
  label: ReactNode;
  openNewWindow?: boolean;
  to?: string;
};

export const MobileLink = (props: Props) => {
  const { closeMobileMenu } = useContext(HeaderContext);

  if (props.disabled) {
    return null;
  }

  const linkContent = (
    <>
      {props.icon && <MobileMenuIcon fixedWidth icon={props.icon} aria-hidden="true" />}
      <span>{props.label}</span>
      {props.extraContent}
    </>
  );

  if (props.href) {
    return (
      <a
        href={props.href}
        target={props.openNewWindow ? '_blank' : undefined}
        rel={props.openNewWindow ? 'noopener noreferrer' : undefined}
        className={props.className}
        onClick={closeMobileMenu}
      >
        {linkContent}
      </a>
    );
  }

  if (props.to) {
    return (
      <NavLink
        exact={props.exact}
        to={props.to}
        onClick={closeMobileMenu}
        className={props.className}
        activeClassName="active"
      >
        {linkContent}
      </NavLink>
    );
  }

  return null;
};
